import axios from 'lib/axios'

const getBrainIdealProfile = async (processId: number) => {
  const brainIdealProfile = await axios
    .get(`/betesa_result/brain_ideal_profile/${processId}`)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return { ok: false, message: error.message }
    })

  return brainIdealProfile
}

export default getBrainIdealProfile
